//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../CloudDM/CloudDM.PartOperationBuilder.js";
let d=[[[0,"AssociatedFilesRootDir",1,0],[0,"DefaultAction",1,0],[0,"ImportAssociatedFiles",1,0],[0,"IncludeDependents",1,0],[0,"MaintainOriginalFolderStructure",1,0],[0,"Naming",1,0],[0,"Prefix",1,0],[0,"Rename",1,0],[0,"ReplaceWith",1,0],[0,"StringToReplace",1,0],[0,"Suffix",1,0]],[[["parts","nErrorMsgs","errorMsgs"],"AddAssembly",{},1,0],[["folderPath","nErrorMsgs","errorMsgs"],"ImportFromFolder",{},1,0],[[],"Dryrun",{},0,0],[["operationObjects","attrTitles"],"ResetAttributes",{},2,0]],[]];
SPLM.CloudDM.PartOperationImportBuilder = class extends SPLM.CloudDM.PartOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CloudDM.PartOperationImportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.PartOperationImportBuilder.ExistingPartAction = Object.freeze({
    "Overwrite" : "Overwrite", "UseExisting" : "UseExisting", "NewCopy" : "NewCopy"});

SPLM.CloudDM.PartOperationImportBuilder.NamingTechnique = Object.freeze({
    "None" : "None", "Prefix" : "Prefix", "Suffix" : "Suffix", "Rename" : "Rename", "ReplaceString" : "ReplaceString", "Mixed" : "Mixed"});

export default SPLM;